import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './ContentSelector.module.sass';
import { shopsActions } from '../../actions';
import { showOnMapSelector, viewAllShopsSelector, directionModeSelector } from '../../selectors/shops';
import ClickableDiv from '../../../ui_kit/clickable_div/ClickableDiv';

class ContentSelector extends React.PureComponent {
  render() {
    const {
      showOnMap, setShowOnMap, viewAllShops, directionMode,
    } = this.props;
    if (viewAllShops || directionMode) { return null; }
    return (
      <div className={styles.wrapper}>
        <div className={styles.selectors}>
          <ClickableDiv className={`${styles.map} ${showOnMap ? styles.active : ''}`} onClick={() => { setShowOnMap(true); }}>
            Map
          </ClickableDiv>
          <ClickableDiv className={`${styles.list} ${!showOnMap ? styles.active : ''}`} onClick={() => { setShowOnMap(false); }}>
            List
          </ClickableDiv>
        </div>
      </div>
    );
  }
}

ContentSelector.propTypes = {
  showOnMap: PropTypes.bool.isRequired,
  setShowOnMap: PropTypes.func.isRequired,
  viewAllShops: PropTypes.bool.isRequired,
  directionMode: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  showOnMap: showOnMapSelector(state),
  viewAllShops: viewAllShopsSelector(state),
  directionMode: directionModeSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  setShowOnMap: (showOnMap) => { dispatch(shopsActions.setShowOnMap(showOnMap)); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ContentSelector);
